// _sources/js/modules/lenis.js
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;

/**
 * Refresh complet Lenis + ScrollTrigger
 * À appeler après modification du layout (accordéon, tabs, modales…)
 */
export function refreshLenisScroll() {
  if (!lenisInstance) return;
  lenisInstance.raf(performance.now());
  ScrollTrigger.refresh();
}

/**
 * Initialise Lenis
 */
export function initLenis() {
  if (lenisInstance) return lenisInstance;

  lenisInstance = new Lenis({
    duration: 1.1,
  });

  lenisInstance.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenisInstance.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  window.addEventListener('resize', refreshLenisScroll);
  window.addEventListener('orientationchange', refreshLenisScroll);

  return lenisInstance;
}

export function getLenis() {
  return lenisInstance;
}
